<template>
  <div class="servicesWrap">
    <div class="servicesResult">
      <img style="width: 100px; margin: 20px;" src="https://h5.tc-rescue.com/snServices/images/icon_success.png">
      <h3>预约成功</h3>
      <van-image width="200" height="200" :src="qrCodeUrl" />
      <div id="orderCode" ref="orderCode" class="orderCode"></div>
      <p>{{orderId}}</p>
      <div style="text-align: center">
        <van-button type="primary" size="small" @click="$router.back()" style="margin: 20px 10px 20px 0;padding: 10px 30px;">返回</van-button>
        <van-button type="info" size="small" @click="$router.push({path:'/servicesUser'})" style="padding: 10px 20px;">我的预约</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import util from '@/utils';
import Data from '@/utils/data';
import { isWeiXin, isSafari } from '@/utils';
import QRCode from 'qrcode-generator';
import {orderEvaluate} from "@/apis/rescue";



export default {
    data(){
        return {
            orderId: "",
            qrCodeUrl:"",
            form: {
              order_id:"",
              rate_value: 0,
              rate_desc:"",
              is_battery: '',
              is_aftersale: '',
              battery_date: "",
              battery_cost: "",
            },
            showPicker:false,
            submitLoading:false,
            columns:[
              { text: '6个月', value: '6' },
              { text: '12个月', value: '12' },
              { text: '18个月', value: '18' },
              { text: '24个月', value: '24' },
              { text: '36个月', value: '36' },
              { text: '其他', value: '-1' },
            ]
        }
    },
    created(){
        this.orderId = this.$route.query.id;
        this.creatQrCode(this.orderId);
    },
    mounted(){

    },
    methods: {
        creatQrCode(url){
            const qr = QRCode(0, 'M')
            qr.addData(url)
            qr.make()
            this.qrCodeUrl = qr.createDataURL(8, 10)
        }
    }
}
</script>

<style lang='scss' scoped>
.servicesResult{
  text-align: center;
  p {
    font-size: 26px;
  }
  h3{
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
  }
}
</style>
